<div
    [ngClass]="{
        'scss-block-background-color-variable': type === WebsiteBlockEmbedType.AccentBackgroundDefault,
        'scss-website-background-color-only': type === WebsiteBlockEmbedType.Default
    }">
    @switch (Scope.websiteMode) {
        @case (WebsiteMode.Live) {
            <ng-container *ngTemplateOutlet="blockContentTemplate"></ng-container>
        }
        @case (WebsiteMode.ReadOnly) {
            <ng-container *ngTemplateOutlet="blockContentTemplate"></ng-container>
        }
        @case (WebsiteMode.Preview) {
            <lib-design-blocks-action-menu>
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </lib-design-blocks-action-menu>
        }
    }
</div>

<ng-template #blockContent>
    <div
        class="d-flex video-block fullWidth justify-content-center"
        [ngClass]="{
            'scss-spacing-embed-block': !isFullWidth && (Scope.websiteMode === WebsiteMode.Preview || Scope.websiteMode === WebsiteMode.Live)
        }">
        @if (designBlockMode === DesignBlockMode.Sidebar) {
            <div class="scss-video-block-sidebar d-flex align-items-center justify-content-center">
                <lib-icon
                    [ngClass]="{
                        'icon-default': type === WebsiteBlockEmbedType.AccentBackgroundDefault,
                        'icon-accent': type === WebsiteBlockEmbedType.Default
                    }"
                    [icon]="Icon.Brand.Youtube"
                    [size]="IconSize.ExtraLarge"></lib-icon>
            </div>
        } @else {
            @if ((Scope.websiteMode === WebsiteMode.Preview || Scope.websiteMode === WebsiteMode.ReadOnly) && !url) {
                <div class="sb-empty-state-background-card margin-24">
                    <lib-empty-state
                        [emptyStateGraphic]="EmptyStateGraphic.OnlineResources">
                        <ng-container
                            emptyStateText
                            i18n="@@Common_EmbedVideoBlock_EmptyState_Title">
                            No video added yet
                        </ng-container>
                        <ng-container
                            emptyStateDescription
                            i18n="@@Common_EmbedVideoBlock_EmptyState_Description">
                            Add a video link to show a video in this section of your website
                        </ng-container>
                        <ng-container emptyStateButton>
                            <lib-button (clicked)="Scope.HandleBlockAction(websiteBlockData, WebsiteBlockAction.Edit)">
                                <ng-container
                                    label
                                    i18n="@@TPEmbedVideoBlockAddVideoButton">
                                    Add Video
                                </ng-container>
                            </lib-button>
                        </ng-container>
                    </lib-empty-state>
                </div>
            } @else if (url) {
                <div class="scss-video-embed-wrapper">
                    <iframe
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                        [src]="url! | trustUrl"></iframe>
                </div>
            }
        }
    </div>
</ng-template>

<ng-template #blockContentTemplate>
    <div class="d-flex position-relative design-block">
        <ng-container *ngTemplateOutlet="blockContent"></ng-container>
    </div>
</ng-template>
